import { render, staticRenderFns } from "./Settlements.vue?vue&type=template&id=58109354&"
import script from "./Settlements.vue?vue&type=script&lang=js&"
export * from "./Settlements.vue?vue&type=script&lang=js&"
import style0 from "./Settlements.vue?vue&type=style&index=0&id=58109354&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./Settlements.vue?vue&type=custom&index=0&blockType=head"
if (typeof block0 === 'function') block0(component)

export default component.exports